var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 4.16733H2.5L5.24167 1.42566C5.31977 1.34819 5.38177 1.25602 5.42408 1.15447C5.46638 1.05293 5.48817 0.944004 5.48817 0.833994C5.48817 0.723984 5.46638 0.615062 5.42408 0.513513C5.38177 0.411964 5.31977 0.319796 5.24167 0.242327C5.08553 0.0871179 4.87432 0 4.65417 0C4.43401 0 4.2228 0.0871179 4.06667 0.242327L0.491667 3.82566C0.178677 4.13679 0.00186066 4.55935 0 5.00066C0.00405549 5.43908 0.180704 5.85825 0.491667 6.16733L4.06667 9.75066C4.14437 9.82781 4.2365 9.8889 4.33781 9.93045C4.43912 9.97199 4.54762 9.99318 4.65711 9.99279C4.76661 9.9924 4.87496 9.97045 4.97597 9.92819C5.07698 9.88593 5.16868 9.82419 5.24583 9.74649C5.32299 9.6688 5.38408 9.57666 5.42562 9.47535C5.46717 9.37404 5.48835 9.26554 5.48796 9.15605C5.48758 9.04655 5.46563 8.93821 5.42337 8.83719C5.38111 8.73618 5.31937 8.64448 5.24167 8.56733L2.5 5.83399H10.8333C11.0543 5.83399 11.2663 5.7462 11.4226 5.58992C11.5789 5.43364 11.6667 5.22167 11.6667 5.00066C11.6667 4.77965 11.5789 4.56769 11.4226 4.41141C11.2663 4.25513 11.0543 4.16733 10.8333 4.16733Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.8ebfbef0416ae9cd94539af109a2e85f.svg";
export { ForwardRef as ReactComponent };